// Recover stalled viewport wheel scrolling without replacing native scroll owners.
(function () {
  'use strict';
  var pending = null;
  document.addEventListener('wheel', function (event) {
    var target = event.target instanceof Element ? event.target : null;
    var body = document.body;
    var root = document.scrollingElement;
    if (!target || !body || !body.matches('.t-PageBody') || !root ||
        event.ctrlKey || event.shiftKey || !event.deltaY || Math.abs(event.deltaX) > Math.abs(event.deltaY) ||
        body.classList.contains('apex-no-scroll') || !target.closest('#t_Body_content') ||
        target.closest('input,textarea,select,[contenteditable]:not([contenteditable="false"]),[role="dialog"],[role="listbox"],[role="menu"],.a-Map,.ui-dialog')) {
      return;
    }
    // A native pane, editor or other nested scroll container keeps its ownership,
    // including its boundary/chaining behavior. Never move the document for it.
    for (var parent = target; parent && parent !== body; parent = parent.parentElement) {
      var style = getComputedStyle(parent);
      if (parent.scrollHeight > parent.clientHeight + 1 && /auto|scroll|overlay/.test(style.overflowY)) { return; }
    }
    if (root.scrollHeight <= root.clientHeight + 1) { return; }
    var delta = event.deltaY * (event.deltaMode === 1 ? 20 : event.deltaMode === 2 ? root.clientHeight : 1);
    if (pending) { pending.delta += delta; pending.events.push(event); return; }
    var request = pending = {start:root.scrollTop,delta:delta,events:[event]};
    // Let native default actions and the compositor run first. If they moved
    // the page, do nothing; this avoids doubling normal wheel scrolling.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        pending = null;
        if (root !== document.scrollingElement || Math.abs(root.scrollTop - request.start) > 1 ||
            request.events.some(function (e) { return e.defaultPrevented; }) || body.classList.contains('apex-no-scroll')) { return; }
        var next = Math.max(0, Math.min(root.scrollHeight - root.clientHeight, request.start + request.delta));
        if (next !== request.start) { window.scrollBy(0, next - request.start); }
      });
    });
  }, {passive:true});
})();
